"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgB = function SvgB(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M71.72 142.854a2.097 2.097 0 01-2.097-2.097V84.96a2.097 2.097 0 114.194 0v55.797a2.097 2.097 0 01-2.097 2.097z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M38.65 142.854a2.097 2.097 0 01-1.797-3.167l33.05-55.804a2.097 2.097 0 113.607 2.14l-33.064 55.796a2.097 2.097 0 01-1.797 1.035z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M104.784 142.854c-.74 0-1.425-.391-1.803-1.028L69.903 86.03a2.097 2.097 0 113.607-2.14l33.064 55.797c.597.987.284 2.27-.699 2.873-.33.196-.707.297-1.09.294z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M39.803 53.469a2.097 2.097 0 01-1.042-3.922l48.422-27.604a2.101 2.101 0 112.097 3.641L40.837 53.19a2.097 2.097 0 01-1.034.28z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M54.909 83.75a2.098 2.098 0 01-1.88-1.167L37.921 52.308a2.098 2.098 0 113.754-1.873l14.246 28.5 3.74-1.615a2.098 2.098 0 111.664 3.851l-5.592 2.405c-.26.113-.541.173-.825.175zM94.767 66.506a2.097 2.097 0 01-.831-4.027l19.614-8.486a2.098 2.098 0 011.664 3.852L95.599 66.33a2.098 2.098 0 01-.832.175z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M117.737 62.717a2.097 2.097 0 01-1.88-1.16L92.496 14.722a2.097 2.097 0 01.936-2.797L116.864.224a2.097 2.097 0 012.796.936l18.985 37.986a2.097 2.097 0 11-3.732 1.901L116.857 4.893 97.165 14.73l22.425 44.954a2.097 2.097 0 01-.937 2.796c-.282.15-.596.231-.916.238zM15.267 70.022a2.097 2.097 0 01-1.007-3.943l17.322-9.458a2.097 2.097 0 012.006 3.684l-17.322 9.458c-.306.168-.65.257-1 .259zM3.977 82.89a2.097 2.097 0 01-.936-3.977l14.176-7.074a2.098 2.098 0 111.873 3.754L4.893 82.667a2.146 2.146 0 01-.916.224z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M9.821 94.607a2.097 2.097 0 01-.936-3.978l14.183-7.074a2.098 2.098 0 111.873 3.754l-14.183 7.06c-.29.15-.61.23-.937.238z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M10.814 97.675a2.097 2.097 0 01-1.88-1.167L.224 79.032a2.098 2.098 0 113.753-1.873l8.71 17.476a2.097 2.097 0 01-.936 2.796c-.29.152-.61.235-.937.244zM117.737 62.717a2.097 2.097 0 01-.936-3.999l23.431-11.694a2.097 2.097 0 111.867 3.753l-23.425 11.716c-.29.148-.611.225-.937.224zM26.906 93.348a2.097 2.097 0 01-1.88-1.16l-11.64-23.327a2.098 2.098 0 113.754-1.873l10.737 21.516 23.977-10.912a2.097 2.097 0 011.734 3.817L27.772 93.153a2 2 0 01-.866.195z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M71.79 86.896a15.093 15.093 0 01-6.99-1.726 15.28 15.28 0 01-7.69-17.427 2.097 2.097 0 014.048 1.09 11.024 11.024 0 0020.412 7.962 11.003 11.003 0 00-4.677-14.847 11.03 11.03 0 00-7.382-1.014 2.097 2.097 0 11-.866-4.103c7.666-1.622 15.31 2.844 17.664 10.318A15.183 15.183 0 0171.79 86.896z",
    fill: "#1B7"
  })));
};

var _default = SvgB;
exports["default"] = _default;